import React from 'react'

import { SupervisorsParams } from 'services/api/SupervisorsApi'

import { AppButton } from 'components/AppButton'
import { AppFiltersLayout } from 'components/AppFiltersLayout'
import { AppSelect } from 'components/AppSelect'

import { Region } from 'models/region'

interface Props {
  regions: Region[]
  onSubmit?(values: SupervisorsParams): void
}

export const SupervisorsDetailsHeader: React.FC<Props> = ({
  regions,
  onSubmit,
}) => {
  const [region, setRegion] = React.useState('')
  const [mounted, setMounted] = React.useState(false)

  const regionList = regions.map(item => ({
    title: item.name,
    value: item.id,
  }))

  function _submit() {
    onSubmit?.({ region })
  }

  async function _reset() {
    setRegion('')
  }

  React.useEffect(() => {
    setMounted(true)
    if (region === '' && mounted) {
      onSubmit?.({ region: '' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [region])

  return (
    <AppFiltersLayout
      controls={
        <>
          <AppButton size="small" onClick={_submit}>
            Применить
          </AppButton>
          <AppButton size="small" variant="red" onClick={_reset}>
            Сбросить
          </AppButton>
        </>
      }
    >
      <AppSelect
        size="extra_small"
        text={regionList.find(item => item.value === Number(region))?.title}
        onChangeValues={([value = '']) => setRegion(value)}
        list={regionList}
        label="Регион"
      />
    </AppFiltersLayout>
  )
}
